var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useEffect, useLayoutEffect, isValidElement, } from 'react';
import classnames from 'classnames';
import { Icons } from '@beeline/design-tokens/js/iconfont';
import { useBEM } from '../../utils';
import { Search } from '../Search';
import { DropdownMenu } from '../DropdownMenu';
import { IconButton } from '../IconButton';
import { TextField } from '../TextField';
import "./styles.css";
var _a = useBEM('lk-ui__autocomplete'), autocompleteClassName = _a[0], _selectModifier = _a[1], selectElement = _a[2];
var _b = selectElement('options'), optionsClassName = _b[0], _optionsModifier = _b[1], optionsElement = _b[2];
var _c = optionsElement('item'), itemClassName = _c[0], itemModifier = _c[1];
export var Autocomplete = function (_a) {
    var _b, _c;
    var size = _a.size, value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue, onClose = _a.onClose, onOpen = _a.onOpen, open = _a.open, children = _a.children, onFocus = _a.onFocus, onBlur = _a.onBlur, onSubmit = _a.onSubmit, onClick = _a.onClick, options = _a.options, fullWidth = _a.fullWidth, className = _a.className, disabled = _a.disabled, defaultGroupID = _a.defaultGroupID, renderValue = _a.renderValue, onInputChange = _a.onInputChange, onInputClear = _a.onInputClear, onFilterChange = _a.onFilterChange, filterItems = _a.filterItems, selectedFilter = _a.selectedFilter, _d = _a.enableGrouping, enableGrouping = _d === void 0 ? false : _d, makeOption = _a.makeOption, label = _a.label, helperText = _a.helperText, type = _a.type, noOptionsText = _a.noOptionsText, loading = _a.loading, loadingText = _a.loadingText, _e = _a.hideDropDown, hideDropDown = _e === void 0 ? false : _e, props = __rest(_a, ["size", "value", "onChange", "defaultValue", "onClose", "onOpen", "open", "children", "onFocus", "onBlur", "onSubmit", "onClick", "options", "fullWidth", "className", "disabled", "defaultGroupID", "renderValue", "onInputChange", "onInputClear", "onFilterChange", "filterItems", "selectedFilter", "enableGrouping", "makeOption", "label", "helperText", "type", "noOptionsText", "loading", "loadingText", "hideDropDown"]);
    var searchInputRef = useRef(null);
    var containerRef = useRef(null);
    var optionsRef = useRef(null);
    var switchButtonRef = useRef(null);
    var isSearch = type === 'search';
    var _f = useState(open), isOpen = _f[0], setOpen = _f[1];
    var _g = useState(isSearch
        ? (_b = searchInputRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth
        : (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth), dropdownWidth = _g[0], setDropdownWidth = _g[1];
    var _h = useState(value ? renderValue(value) : ''), inputValue = _h[0], setInputValue = _h[1];
    useLayoutEffect(function () {
        var _a, _b;
        setDropdownWidth(isSearch
            ? (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth
            : (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth);
    });
    useEffect(function () {
        setOpen(open);
    }, [open]);
    useEffect(function () {
        var newInputValue = value ? renderValue(value) : '';
        setInputValue(newInputValue);
    }, [value]);
    var handleOpen = function () {
        setOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    };
    var handleClose = function () {
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var onSelectItem = function (item) { return function () {
        onChange(item);
        handleClose();
    }; };
    var handleInputFocus = function (event) {
        if (!isOpen)
            handleOpen();
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    var handleInputBlur = function (event) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    var handleInputOnChange = function (event) {
        setInputValue(event.target.value);
        onInputChange(event.target.value);
    };
    var handleInputOnClear = function () {
        setInputValue('');
        onInputClear();
        onInputChange('');
    };
    useEffect(function () {
        var handleOutsideClick = function (event) {
            var targetElement = event === null || event === void 0 ? void 0 : event.composedPath()[0];
            var selectElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
            var searchElement = searchInputRef.current;
            var optionsElement = optionsRef === null || optionsRef === void 0 ? void 0 : optionsRef.current;
            var buttonElement = switchButtonRef === null || switchButtonRef === void 0 ? void 0 : switchButtonRef.current;
            var isOutsideClick = ![
                searchElement,
                selectElement,
                optionsElement,
                buttonElement,
            ].some(function (element) { return element && element.contains(targetElement); });
            if (isOutsideClick) {
                handleClose();
            }
        };
        window.addEventListener('mousedown', handleOutsideClick);
        return function () { return window.removeEventListener('mousedown', handleOutsideClick); };
    }, []);
    var makeItem = function (item, _inputValue) {
        var className = classnames(itemClassName);
        var customComponent = makeOption(item, _inputValue);
        return ((customComponent && (React.createElement("div", { key: item.id.toString(), className: className, onClick: onSelectItem(item) }, customComponent))) ||
            null);
    };
    var makeOptions = function (inputValue) {
        var optionsComponents = options
            .map(function (item) { return makeItem(item, inputValue); })
            .filter(function (component) { return component !== null; });
        var hasMatching = !!optionsComponents.length;
        return (React.createElement("div", { className: optionsClassName, ref: optionsRef, style: { width: dropdownWidth } }, loading ? (isValidElement(loadingText) ? (loadingText) : (React.createElement("span", { className: itemModifier('empty') }, loadingText || 'Загрузка'))) : hasMatching ? (optionsComponents) : isValidElement(noOptionsText) ? (noOptionsText) : (React.createElement("span", { className: itemModifier('empty') }, noOptionsText || 'Нет результатов'))));
    };
    var optionsComponents = makeOptions(inputValue);
    var dropdownMenuProps = {
        targetElement: isSearch ? searchInputRef : containerRef,
        align: 'center',
        verticalOffset: 0,
    };
    var rootClassName = classnames(autocompleteClassName, className);
    var makeDropdownView = function () {
        var rightIcon = (React.createElement(IconButton, { ref: switchButtonRef, size: size, iconName: isOpen ? Icons.NavArrowUp : Icons.NavArrowDown, onClick: isOpen ? handleClose : handleOpen, disabled: disabled }));
        return (React.createElement(TextField, __assign({}, props, { ref: searchInputRef, containerRef: containerRef, label: label, size: size, fullWidth: fullWidth, endAdornment: rightIcon, onChange: handleInputOnChange, onBlur: handleInputBlur, onFocus: handleInputFocus, disabled: disabled, value: inputValue, contentEditable: true })));
    };
    var makeSearchView = function () {
        var filterByGroupProps = enableGrouping
            ? {
                filterItems: filterItems,
                selectedFilter: selectedFilter,
                onFilterChange: onFilterChange,
            }
            : {};
        return (React.createElement(Search, __assign({}, props, filterByGroupProps, { ref: searchInputRef, size: size, fullWidth: fullWidth, onBlur: handleInputBlur, onFocus: handleInputFocus, onChange: handleInputOnChange, onClear: handleInputOnClear, disabled: disabled, value: inputValue, contentEditable: false })));
    };
    return (React.createElement("div", { className: rootClassName },
        isSearch ? makeSearchView() : makeDropdownView(),
        isOpen && !hideDropDown && (React.createElement(DropdownMenu, __assign({}, dropdownMenuProps), optionsComponents))));
};
